<template>
    <div class="container" id="Activities">
        <div class="row">
            <div v-for="(item,index) in items" :key="index"
                 class="col-xs-12 col-sm-4 col-md-4 col-lg-4 text-center">
                <v-card class="mx-auto my-12" @click="$vuetify.goTo('#' + item.section, {})">
                    <v-img class="py-5">
                        <v-btn fab x-large color="primary">
                            <v-icon x-large>{{ item.icon }}</v-icon>
                        </v-btn>
                    </v-img>
                    <v-card-title>{{ item.title }}</v-card-title>
                    <v-card-text>{{ item.text }}</v-card-text>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CActivities",
        data: () => ({
            items: [
                {
                    icon: 'fa fa-home',
                    title: 'Bootcamps & trainings',
                    text: 'Hands-on bootcamps and trainings where participants learn idea building, business planning, programming, digital skills, and pitching.',
                    section: 'Bootcamps',
                },
                {
                    icon: 'fa fa-calendar',
                    title: 'Events',
                    text: 'Events include networking meetings, hackathons, HackOmations, and bootcamps. Participants share ideas, build teams, and create ICT solutions for real-world problems.',
                    section: 'Events',
                },
                {
                    icon: 'fa fa-laptop',
                    title: 'Tutorials & Moodle',
                    text: 'Online tutorials, training resources, experiences, and discussions about relevant ICT topics and new trends.',
                    section: 'Tutorials',
                }
            ]
        })
    }
</script>

<style scoped>
        .v-card {
            height: 100%;
            transition: transform .2s ease, box-shadow .2s ease;
        }
        .v-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 14px 28px rgba(103, 48, 141, .18) !important;
    }

</style>
